import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { StateType } from 'types';
import {
  selectIsLoading,
  selectSectorOptions,
  selectStartupCount,
  selectStartupFilters,
  selectStartups,
  selectStartupFiltersActive,
} from 'redux/selectors/startups';
import {
  getStartups,
  getStartupCount,
  getStartupSectors,
  setStartupId,
  setStartupFilters,
} from 'redux/actions/startups';
import { setIsDrawerOpen, setDrawerBody, setTableLayout } from 'redux/actions/workspace';
import { selectUserType } from 'redux/selectors/auth';
import { selectIsRowTableLayout } from 'redux/selectors/workspace';

const mapStateToProps = (state: StateType) => ({
  startups: selectStartups(state),
  userType: selectUserType(state),
  isLoading: selectIsLoading(state),
  startupCount: selectStartupCount(state),
  sectorOptions: selectSectorOptions(state),
  isRowTableLayout: selectIsRowTableLayout(state),
  filters: selectStartupFilters(state),
  filtersActive: selectStartupFiltersActive(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getStartups,
    getStartupCount,
    getStartupSectors,
    setIsDrawerOpen,
    setDrawerBody,
    setStartupId,
    setStartupFilters,
    setTableLayout,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
